$(document).ready(function() {
  // Hide all answers except the first one by default
  $('.rewards-loyalty-answer').not(':first').hide();

  // Add a class to the first question-answer parent to indicate it's open
  $('.rewards-loyalty-question:first').closest('.rewards-loyalty-question-answer').addClass('rewards-active');

  // Toggle answers when clicking on the question
  $('.rewards-loyalty-question').click(function() {
    var answer = $(this).next('.rewards-loyalty-answer');
    var plusIcon = $(this).find('.rewards-icon-plus');
    var minusIcon = $(this).find('.rewards-icon-minus');

    // Toggle answer visibility
    answer.slideToggle();

    // Toggle plus and minus icons
    plusIcon.toggle();
    minusIcon.toggle();

    // Close other answers
    $('.rewards-loyalty-answer').not(answer).slideUp();
    $('.rewards-loyalty-question').not(this).closest('.rewards-loyalty-question-answer').removeClass('rewards-active');

    // Toggle active class on the clicked question-answer parent
    answer.closest('.rewards-loyalty-question-answer').toggleClass('rewards-active');
  });
});